/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetAllowedChangesResponse,
  GetContractsResponse,
  IsContractPresentResponse,
  SetInflationProgramRequest,
} from '../models/index';
import {
    GetAllowedChangesResponseFromJSON,
    GetAllowedChangesResponseToJSON,
    GetContractsResponseFromJSON,
    GetContractsResponseToJSON,
    IsContractPresentResponseFromJSON,
    IsContractPresentResponseToJSON,
    SetInflationProgramRequestFromJSON,
    SetInflationProgramRequestToJSON,
} from '../models/index';

export interface ChangeInflationProgramPutRequest {
    contractId: string;
    setInflationProgramRequest: SetInflationProgramRequest;
}

export interface IsContractPresentGetRequest {
    contractId: string;
}

/**
 * 
 */
export class ContractsApi extends runtime.BaseAPI {

    /**
     * Set inflation program for given contract
     */
    async changeInflationProgramPutRaw(requestParameters: ChangeInflationProgramPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['contractId'] == null) {
            throw new runtime.RequiredError(
                'contractId',
                'Required parameter "contractId" was null or undefined when calling changeInflationProgramPut().'
            );
        }

        if (requestParameters['setInflationProgramRequest'] == null) {
            throw new runtime.RequiredError(
                'setInflationProgramRequest',
                'Required parameter "setInflationProgramRequest" was null or undefined when calling changeInflationProgramPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"]);
        }


        let urlPath = `/contracts/{contractId}/change-inflation-program`;
        urlPath = urlPath.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters['contractId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetInflationProgramRequestToJSON(requestParameters['setInflationProgramRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Set inflation program for given contract
     */
    async changeInflationProgramPut(requestParameters: ChangeInflationProgramPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.changeInflationProgramPutRaw(requestParameters, initOverrides);
    }

    /**
     * Get list of allowed changes for all contracts for a PID/MPK
     */
    async getAllowedChangesGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAllowedChangesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"]);
        }


        let urlPath = `/contracts/allowed-changes`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAllowedChangesResponseFromJSON(jsonValue));
    }

    /**
     * Get list of allowed changes for all contracts for a PID/MPK
     */
    async getAllowedChangesGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAllowedChangesResponse> {
        const response = await this.getAllowedChangesGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get list of contracts for the current user.
     */
    async getContractsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetContractsResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("ADB2CAuthFlow", ["https://nnczcustomerportaldev.onmicrosoft.com/5d23dca9-d19b-4c16-b403-d27b86222083/CustPortalApi.Default"]);
        }


        let urlPath = `/contracts`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetContractsResponseFromJSON));
    }

    /**
     * Get list of contracts for the current user.
     */
    async getContractsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetContractsResponse>> {
        const response = await this.getContractsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Does contract belong to this portal
     */
    async isContractPresentGetRaw(requestParameters: IsContractPresentGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IsContractPresentResponse>> {
        if (requestParameters['contractId'] == null) {
            throw new runtime.RequiredError(
                'contractId',
                'Required parameter "contractId" was null or undefined when calling isContractPresentGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/contracts/present/{contractId}`;
        urlPath = urlPath.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters['contractId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IsContractPresentResponseFromJSON(jsonValue));
    }

    /**
     * Does contract belong to this portal
     */
    async isContractPresentGet(requestParameters: IsContractPresentGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IsContractPresentResponse> {
        const response = await this.isContractPresentGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
